import { Course } from '@icofcv/common';

// Un curso está "completo" si el admin lo marcó agotado,
// o si tiene un nº de plazas definido y los inscritos confirmados (estados 2/3) lo alcanzan.
export const isCourseFull = (course?: Course | null): boolean => {
  if (!course) return false;
  if (course.soldOutPlaces) return true;
  const places = course.places;
  const numInscritos = typeof course.numInscritos === 'number' ? course.numInscritos : 0;
  const reservedPlaces = typeof course.reservedPlaces === 'number' ? course.reservedPlaces : 0;
  if (places && places > 0 && (numInscritos + reservedPlaces) >= places) {
    return true;
  }
  return false;
};
